<template>
  <div class="flex w-full p-2 bg-yellow-200 border border-yellow-400" v-if="active">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "LInfoBox",
  props: ["active"]
};
</script>